import { Component, input } from '@angular/core';

@Component({
  selector: 'lgb-progress',
  standalone: false,
  templateUrl: './progress.html',
  styleUrl: './progress.css',
})
export class Progress {
  readonly msg=input('Analyse en cours...');
}
